// Prepare status chart data
export const prepareStatusChartData = (projects, statusColors) => {
  try {
    if (!projects || projects.length === 0) {
      return {
        labels: ['No Projects'],
        datasets: [
          {
            data: [1],
            backgroundColor: ['#e0e0e0'],
            borderWidth: 1,
          },
        ],
      };
    }

    // Count projects by status
    const statusCounts = {};
    projects.forEach(project => {
      const status = project.status || 'unknown';
      statusCounts[status] = (statusCounts[status] || 0) + 1;
    });

    // Prepare chart data
    const labels = Object.keys(statusCounts);
    const data = [];
    const backgroundColors = [];

    labels.forEach(status => {
      data.push(statusCounts[status]);
      backgroundColors.push(statusColors[status] || '#757575');
    });

    return {
      labels,
      datasets: [
        {
          data,
          backgroundColor: backgroundColors,
          borderWidth: 1,
        },
      ],
    };
  } catch (error) {
    console.error('Error preparing chart data:', error);
    return {
      labels: ['Error'],
      datasets: [
        {
          data: [1],
          backgroundColor: ['#f44336'],
          borderWidth: 1,
        },
      ],
    };
  }
};

// Prepare progress chart data
export const prepareProjectProgressChartData = (activeProjects) => {
  try {
    // If no active projects, return empty chart data
    if (!activeProjects || activeProjects.length === 0) {
      return {
        labels: ['No Active Projects'],
        datasets: [
          {
            label: 'Progress (%)',
            data: [0],
            backgroundColor: ['rgba(224, 224, 224, 0.6)'],
            borderColor: ['rgb(224, 224, 224)'],
            borderWidth: 1,
          }
        ],
      };
    }

    // Sort by progress and take top 5 projects
    const sortedProjects = [...activeProjects].sort((a, b) => (b?.progress || 0) - (a?.progress || 0));
    const topProjects = sortedProjects.slice(0, 5);

    const labels = topProjects.map(p => p.name || 'Unknown');
    const data = topProjects.map(p => p.progress || 0);
    const backgroundColors = data.map(progress => 
      progress >= 80 ? 'rgba(76, 175, 80, 0.6)' : 
      progress >= 50 ? 'rgba(255, 152, 0, 0.6)' : 
      'rgba(244, 67, 54, 0.6)'
    );
    const borderColors = data.map(progress => 
      progress >= 80 ? 'rgb(76, 175, 80)' : 
      progress >= 50 ? 'rgb(255, 152, 0)' : 
      'rgb(244, 67, 54)'
    );

    return {
      labels,
      datasets: [
        {
          label: 'Progress (%)',
          data,
          backgroundColor: backgroundColors,
          borderColor: borderColors,
          borderWidth: 1,
        }
      ],
    };
  } catch (error) {
    console.error('Error preparing progress chart data:', error);
    return {
      labels: ['Error'],
      datasets: [
        {
          label: 'Progress (%)',
          data: [0],
          backgroundColor: ['rgba(244, 67, 54, 0.6)'],
          borderColor: ['rgb(244, 67, 54)'],
          borderWidth: 1,
        }
      ],
    };
  }
};
